import React from 'react';
import { SvgProps, useDefaultColor } from '../core';

interface ArrowHeadProps extends SvgProps {
  direction?: 'left' | 'right' | 'up' | 'down';
  rotateDimensions?: boolean;
}

const transform = {
  up: 'rotate(0deg)',
  down: 'rotate(180deg)',
  left: 'rotate(-90deg)',
  right: 'rotate(90deg)',
};

const ArrowHead: React.FC<ArrowHeadProps> = ({
  color,
  width,
  height,
  style,
  className,
  direction = 'right',
  rotateDimensions = false,
}) => {
  const resolvedColor = useDefaultColor(color);
  const swapWidthHeight =
    !rotateDimensions && (direction === 'left' || direction === 'right');

  return (
    <svg
      style={{ ...(style ?? {}), transform: transform[direction] }}
      className={className}
      width={(swapWidthHeight ? height : width) ?? 14}
      height={(swapWidthHeight ? width : height) ?? 8}
      viewBox="0 0 14 8"
      fill="none"
    >
      <path
        d="M13 7L7 1 1 7"
        stroke={resolvedColor}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowHead;
